import React from 'react'
import SubAdmin from '../masterLayout/SubAdmin'
import Breadcrumb from '../components/Breadcrumb'
import AddTeamForm from '../components/child/AddTeamForm'

const AddTeam = () => {
  return (
        <SubAdmin>
        <Breadcrumb title="Add Team" />
        <AddTeamForm />


    </SubAdmin>   )
}

export default AddTeam